import { useLocation, useNavigate, useParams } from "react-router-dom";

function withRouter(Component) {
  return function Wrapper(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    const safeNavigate = (to, options) => {
      if (typeof to === "string" && !to.startsWith("/")) {
        to = "/" + to;
      }
      navigate(to, options);
    };
    

    return (
      <Component
        {...props}
        router={{ location, navigate: safeNavigate, params }}
      />
    );
  };
}

export default withRouter;
